export default __webpack_public_path__ + "static/media/training-image-04.3556d209.jpg";